var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#5A6E89",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-sliders-horizontal-icon lucide-sliders-horizontal",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5H3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19H3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17v4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12h-9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19h-5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5h-7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10v4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.b32826362437c6977b127a3bb6a1e4c1.svg";
export { ForwardRef as ReactComponent };